<div style="width: 500px; height: 400px;" data-cy="fee-doctor-edit-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;" data-cy="fee-doctor-edit-section">
    <div class="section-header" style="flex-basis: 30px;" data-cy="fee-doctor-edit-header">
      <div class="section-header-title" data-cy="fee-doctor-edit-title">
        Edit Doctor Fee Schedule.
      </div>
      <div style="flex: 1;"></div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1; text-align: left;" data-cy="fee-doctor-edit-content">
      <div class="description-div" data-cy="fee-doctor-edit-description-div">
        <mat-form-field class="full-width" data-cy="fee-doctor-edit-description-field">

          <span data-cy="fee-doctor-edit-doctor-name">Created For: {{dataDoctor.DoctorName}}</span><br/><br/>
          <span data-cy="fee-doctor-edit-description-label">Description to Display:</span>
          <input matInput
                 [(ngModel)]="dataDoctor.Description"
                 data-cy="fee-doctor-edit-description-input"
                 />
        </mat-form-field>
      </div>
      <div class="providerid-div" data-cy="fee-doctor-edit-providerid-div">
        <mat-form-field class="full-width" data-cy="fee-doctor-edit-providerid-field">
          <span data-cy="fee-doctor-edit-providerid-label">Enter an insurance provider ID:</span>
          <input matInput
                 [(ngModel)]="dataDoctor.ProviderIDbyInsurance"
                 data-cy="fee-doctor-edit-providerid-input"
                 />
        </mat-form-field>
      </div>
      <div class="isactive-div" data-cy="fee-doctor-edit-isactive-div">
<!--        <mat-slide-toggle [(ngModel)]="dataDoctor.isActive">Is Active</mat-slide-toggle-->
        <mat-checkbox [checked]="dataDoctor.isActive" (change)="valueIsActiveChange($event)" data-cy="fee-doctor-edit-isactive-checkbox"> Is Active</mat-checkbox>

      </div>
    </div>
    <!--  FOOTER-->
    <div *ngIf="isMutipleActiveInsurance == false" data-cy="fee-doctor-edit-standard-footer">


      <div style="float:right;" data-cy="fee-doctor-edit-standard-buttons">
        <button (click)="close()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="fee-doctor-edit-cancel-button">Cancel</button>
        <button (click)="save(true)" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="fee-doctor-edit-save-button">Save/Close</button>
      </div>
    </div>
    <div *ngIf="isMutipleActiveInsurance" data-cy="fee-doctor-edit-multiple-footer">
      <span style="float: left; margine-left:6px;" data-cy="fee-doctor-edit-multiple-warning">Mutiple Active Fee Schedules! Clear All and make this Active?</span>

      <div style="float:right;" data-cy="fee-doctor-edit-multiple-buttons">
        <button (click)="close()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="fee-doctor-edit-multiple-cancel-button">Cancel</button>
        <button (click)="save(false)" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="fee-doctor-edit-multiple-yes-button">Yes/Close</button>
      </div>
    </div>


    <!--    <div class="section-footer" style="flex-basis: 60px; padding-top: 3px;">-->
<!--      -->
<!--      <span style="flex:left ">Some text here </span>-->
<!--      -->
<!--      <div style="flex: 1; margin-right: 6px;"></div>-->
<!--      -->
<!--      <button (click)="close()" class="tdo-button tdo-close" style="margin-right: 6px;">Cancel</button>-->
<!--      <button (click)="save()" class="tdo-button tdo-save" style="margin-right: 6px;">Ok</button>-->
<!--    </div>-->
  </div>
</div>

<!--<div *ngIf="!isLoading" class="main-container full-width">
  <div>
    <h5>Edit Doctor Fee Schedule</h5>
  </div>
<br />
  <div class="description-div">
    <mat-form-field class="full-width">
      <input matInput
             [(ngModel)]="dataDoctor.Description"
             placeholder="Enter a description"/>
    </mat-form-field>
  </div>

  <div class="button-div">
    <button mat-raised-button color="primary" class="action-button" (click)="save()">Save</button>
    <button mat-raised-button color="warn" class="action-button" (click)="close()">Cancel</button>
  </div>
</div>
<div *ngIf="isLoading" class="spinner-holder">
  <mat-spinner></mat-spinner>
</div>-->
